const Blank = ({name}) => {
    return (
        <div className="con d-flex justify-content-center align-items-center"> <p className='nav-link disabled display-5 text-capitalize'>{name} Page</p></div>
    )
}

export default Blank